const STATE_ALIASES = {
  Orissa: "Odisha",
  Pondicherry: "Puducherry",
  Chattisgarh: "Chhattisgarh",
  Uttaranchal: "Uttarakhand",
  "Andaman & Nicobar Islands": "Andaman and Nicobar Islands",
  "Daman & Diu": "Dadra and Nagar Haveli and Daman and Diu",
  "Dadra & Nagar Haveli": "Dadra and Nagar Haveli and Daman and Diu",
};

export function normalizeIndianState(state) {
  if (!state) return "";
  return STATE_ALIASES[state] || state;
}

export async function lookupPincode(pincode) {
  const code = String(pincode || "").replace(/\D/g, "");
  if (code.length !== 6) {
    return null;
  }

  const response = await fetch(`https://api.postalpincode.in/pincode/${code}`);
  if (!response.ok) {
    throw new Error("Unable to lookup pincode right now");
  }

  const payload = await response.json();
  const result = Array.isArray(payload) ? payload[0] : payload;

  if (result?.Status !== "Success" || !result?.PostOffice?.length) {
    throw new Error("Invalid pincode");
  }

  const office = result.PostOffice.find((item) => item.DeliveryStatus === "Delivery") || result.PostOffice[0];

  return {
    city: office.District || office.Name || "",
    state: normalizeIndianState(office.State || ""),
    area: office.Name || "",
  };
}
